import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";
import * as helpers from "@styles/emotion-styles/helpers";
import * as layers from "@styles/emotion-styles/layers";

export const autoCompleteDropdown = {
  base: (theme: Theme) => css`
    background-color: ${theme.surface.level1};
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 ${helpers.hexToRgba(theme.surface.overlayBackdrop, 0.25)};
    color: ${theme.text.body};
    position: absolute;
    z-index: ${layers.zIndexMidForeground};
    display: none;

    @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
      width: 100%;
    }
  `,
  state: {
    isSuggesting: css`
      display: inherit;
    `,
  },
};

export const autoCompleteFormField = css`
  &:not(:last-of-type) {
    margin-bottom: 0;
  }
`;

export const autoCompleteSuggestion = (theme: Theme) => css`
  background-color: ${theme.surface.level1};
  cursor: pointer;
  padding: 0.5rem 1.5rem 0.5rem 0.5rem;

  &:not(:last-of-type):not(:first-of-type) {
    margin-bottom: 0.25rem;
  }

  &:last-of-type {
    border-radius: 0 0 4px 4px;
  }

  &.active {
    background-color: ${theme.system.backgroundMuted};
  }

  span {
    display: block;
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
    span {
      white-space: inherit;
    }
  }
`;

export const autoCompleteHeader = (theme: Theme) => css`
  ${autoCompleteSuggestion(theme)}
  color: ${theme.text.body};
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 0.25rem;

  &.active {
    background: inherit;
  }
`;

export const autoCompleteMessage = (theme: Theme) => css`
  ${autoCompleteSuggestion(theme)}
  background: ${theme.surface.level2};
  color: ${theme.text.body};
  font-size: 0.75rem;
`;

export const autoCompleteWrapper = css`
  position: relative;
`;
